/** Picks the column a subtask moves to when its done box is ticked or cleared. */
export function doneToggleStateId(
  states: Array<{ id: string; group?: string | null }>,
  markDone: boolean,
): string | null {
  if (markDone) return states.find((state) => state.group === 'completed')?.id ?? null;
  return states.find((state) => state.group === 'unstarted')?.id
    ?? states.find((state) => state.group === 'backlog')?.id
    ?? states.find((state) => state.group !== 'completed' && state.group !== 'cancelled')?.id
    ?? null;
}
